import * as Constant from "@/utils/constant.js";

/**
 * 获取文件名字
 */
export function getFileName4Url(url) {
  var name = url.substring(url.lastIndexOf("/") + 1);
  return name;
}
/**
 * 性别
 * @param {} sex  男：F / 女：M）
 */
export function gender(sex) {
  switch (sex) {
    case "F":
      return "女";
    case "M":
      return "男";
  }
  return "未知";
}

/**
 * 是否激活
 * @param {} activate  激活 1 / 未激活：0
 */
export function isActivate(activate) {
  switch (activate) {
    case 1:
      return "是";
    case 0:
      return "否";
  }
  return "未知";
}
/**
 * 是否
 * @param {} flag  是 Y / 否：N
 */
export function yesOrNo(flag) {
  switch (flag) {
    case "Y":
      return "是";
    case "N":
      return "否";
  }
  return "未知";
}

export function activateSucOrFail(result) {
  switch (result) {
    case "2":
      return "已有校友邮箱";
    case "1":
      return "激活失败";
    case "0":
      return "激活成功";
  }
  return "";
}

export function isEmpty(str) {
  return str === "" || str === null || str === undefined;
}

export function getDataTimeStr() {
  var today = new Date();
  var month = today.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  var day = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
  var hours = today.getHours() < 10 ? "0" + today.getHours() : today.getHours();
  var mins =
    today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();
  var secs =
    today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
  // var now1 = today.getFullYear() + '/' + month + '/' + day;
  var now1 =
    today.getFullYear() +
    "" +
    month +
    "" +
    day +
    "" +
    hours +
    "" +
    mins +
    "" +
    secs;
  return now1;
}

/**
 * 获取排序
 * @param {*} column
 */
export function getPropOrder(column) {
  // console.log(column);
  var listOrder = "";
  if ("descending" == column.order) {
    listOrder = "" + column.prop + ",desc";
  } else if ("ascending" == column.order) {
    listOrder = "" + column.prop + ",asc";
  } else {
    listOrder = undefined;
  }
  return listOrder;
}

/**
 * 获取所在地排序
 * @param {*} column
 */
export function getLocationPropOrder(column, type) {
  var listOrder = "";
  if ("descending" == column.order) {
    listOrder =
      "" +
      type +
      "_nation,desc;" +
      type +
      "_province,desc;" +
      type +
      "_city,desc";
  } else if ("ascending" == column.order) {
    listOrder =
      "" + type + "_nation,asc;" + type + "_province,asc;" + type + "_city,asc";
  }
  return listOrder;
}
/**
 * 获取状态
 */
export function getAdminState(state) {
  switch (state) {
    case "Y":
      return "已启用";
    case "N":
      return "已禁用";
  }
  return "已禁用";
}
export function getAdminState1(state) {
  switch (state) {
    case "已启用":
    case "Y":
      return "Y";
    case "已禁用":
    case "N":
      return "N";
  }
  return "N";
}
/**
 * 分割多个字段
 * @param {*} string
 */
export function replaceFields(string) {
  if (isEmpty(string)) return string;
  var str = string.replace(/,/g, ";");
  return str;
}

/**
 * 获取深造信息所在地
 * @param {*} element
 */
export function getEduLocation(element) {
  var location = "";
  if (!isEmpty(element.education_nation)) {
    location += element.education_nation;
  }
  if (!isEmpty(element.education_province)) {
    location += "-" + element.education_province;
  }
  if (!isEmpty(element.education_city)) {
    location += "-" + element.education_city;
  }
  var start = location.substring(0, 1);
  if (start == "-") {
    location = location.substring(1, location.length);
  }
  return location;
}

/**
 * 获取校友信息工作所在地
 * @param {*} element
 */
export function getUserJobLocation(element) {
  var location = "";
  if (!isEmpty(element.job_organization_nation)) {
    location += element.job_organization_nation;
  }
  if (!isEmpty(element.job_organization_province)) {
    location += "-" + element.job_organization_province;
  }
  if (!isEmpty(element.job_organization_city)) {
    location += "-" + element.job_organization_city;
  }
  var start = location.substring(0, 1);
  if (start == "-") {
    location = location.substring(1, location.length);
  }
  return location;
}

/**
 * 获取工作信息所在地
 * @param {*} element
 */
export function getJobLocation(element) {
  var location = "";
  if (!isEmpty(element.organization_nation)) {
    location += element.organization_nation;
  }
  if (!isEmpty(element.organization_province)) {
    location += "-" + element.organization_province;
  }
  if (!isEmpty(element.organization_city)) {
    location += "-" + element.organization_city;
  }
  var start = location.substring(0, 1);
  if (start == "-") {
    location = location.substring(1, location.length);
  }
  return location;
}

/**
 * 获取所在地
 * @param {*} element
 */
export function getLocationArray(location) {
  return location.split("-");
}

/**
 * 获取深造信息所在地
 * @param {*} element
 */
export function getEduLocationArray(element) {
  var location = [];
  if (!isEmpty(element.education_nation)) {
    location[0] = element.education_nation;
  }
  if (!isEmpty(element.education_province)) {
    location[1] = element.education_province;
  }
  if (!isEmpty(element.education_city)) {
    location[2] = element.education_city;
  }
  return location;
}

/**
 * 获取工作信息所在地
 * @param {*} element
 */
export function getJobLocationArray(element) {
  var location = [];
  if (!isEmpty(element.organization_nation)) {
    location[0] = element.organization_nation;
  }
  if (!isEmpty(element.organization_province)) {
    location[1] = element.organization_province;
  }
  if (!isEmpty(element.organization_city)) {
    location[2] = element.organization_city;
  }
  return location;
}

/**
 * 获取校友基本信息筛选字段
 */
export function getAisInfoFields(checkList) {
  var fields = "student_no;name_cn;name_en";
  if (checkList.indexOf("入学年份") > -1) {
    fields += ";year";
  }
  if (checkList.indexOf("深造状态") > -1) {
    fields += ";education_status";
  }
  if (checkList.indexOf("工作状态") > -1) {
    fields += ";status";
  }
  if (checkList.indexOf("邮箱是否激活") > -1) {
    fields += ";is_email";
  }
  if (checkList.indexOf("帐号是否激活") > -1) {
    fields += ";is_account";
  }
  if (checkList.indexOf("专业") > -1) {
    fields += ";programme";
  }
  if (checkList.indexOf("学部") > -1) {
    fields += ";division";
  }
  if (checkList.indexOf("出生年份") > -1) {
    fields += ";date_of_birth";
  }
  if (checkList.indexOf("性别") > -1) {
    fields += ";gender";
  }
  if (checkList.indexOf("国家地区") > -1) {
    fields += ";region";
  }
  if (checkList.indexOf("身份证号") > -1) {
    fields += ";id_card_number";
  }
  if (checkList.indexOf("招生类型") > -1) {
    fields += ";admission_category";
  }
  if (checkList.indexOf("荣誉分类") > -1) {
    fields += ";honours_classification";
  }
  if (checkList.indexOf("毕业年份") > -1) {
    fields += ";graduation_year";
  }
  if (checkList.indexOf("联系电话") > -1) {
    fields += ";mobile_phone";
  }
  if (checkList.indexOf("校友邮箱") > -1) {
    fields += ";alumni_email";
  }
  if (checkList.indexOf("常用邮箱") > -1) {
    fields += ";active_email";
  }
  if (checkList.indexOf("微信") > -1) {
    fields += ";wechat";
  }
  if (checkList.indexOf("籍贯-省份") > -1) {
    fields += ";navtive_province";
  }
  if (checkList.indexOf("籍贯-城市") > -1) {
    fields += ";navtive_city";
  }
  if (checkList.indexOf("生源地") > -1) {
    fields += ";origin_place";
  }
  if (checkList.indexOf("生源高中") > -1) {
    fields += ";origin_high_school";
  }
  if (checkList.indexOf("标签") > -1) {
    fields += ";label";
  }
  if (checkList.indexOf("校友类别") > -1) {
    fields += ";alumni_type";
  }
  if (checkList.indexOf("会员类别") > -1) {
    fields += ";member_type";
  }
  if (checkList.indexOf("校友福利") > -1) {
    fields += ";welfare_gymnasium_setting";
  }
  if (checkList.indexOf("是否本硕连读") > -1) {
    fields += ";is_bachelors_masters";
  }
  if (checkList.indexOf("校友状态") > -1) {
    fields += ";alumni_status";
  }
  if (checkList.indexOf("工作所在地") > -1) {
    fields += ";job_organization_nation;job_organization_province;job_organization_city";
  }
  if (checkList.indexOf("工作单位名称") > -1) {
    fields += ";job_organization";
  }
  if (checkList.indexOf("工作单位性质") > -1) {
    fields += ";job_unit_property";
  }
  if (checkList.indexOf("工作行业类型") > -1) {
    fields += ";job_type";
  }
  if (checkList.indexOf("工作职位") > -1) {
    fields += ";job_position";
  }
  if (checkList.indexOf("工作薪酬范围") > -1) {
    fields += ";job_pay";
  }
  if (checkList.indexOf("工作公司注册地") > -1) {
    fields += ";job_registered_address";
  }
  if (checkList.indexOf("工作雇员人数") > -1) {
    fields += ";job_employees";
  }
  if (checkList.indexOf("工作年营业额") > -1) {
    fields += ";job_turnover";
  }
  if (checkList.indexOf("工作从事何种自由职业") > -1) {
    fields += ";job_freelance";
  }
  if (checkList.indexOf("深造所在地") > -1) {
    fields += ";education_nation;education_province;education_city";
  }
  if (checkList.indexOf("深造院校名称") > -1) {
    fields += ";education_school";
  }
  if (checkList.indexOf("深造院校专业") > -1) {
    fields += ";education_programme";
  }
  if (checkList.indexOf("深造毕业年份") > -1) {
    fields += ";education_graduation_year";
  }
  if (checkList.indexOf("深造其他") > -1) {
    fields += ";education_other";
  }
  return fields;
}

/**
 * 获取校友基本信息筛选字段
 */
export function getEduInfoFields(checkList) {
  var fields = "student_no;name_cn;name_en";
  if (checkList.indexOf("专业") > -1) {
    fields += ";programme";
  }
  if (checkList.indexOf("状态") > -1) {
    fields += ";education_status";
  }
  if (checkList.indexOf("所在地") > -1) {
    fields += ";education_nation;education_province;education_city";
  }
  if (checkList.indexOf("院校名称") > -1) {
    fields += ";education_school";
  }
  if (checkList.indexOf("院校专业") > -1) {
    fields += ";education_programme";
  }
  if (checkList.indexOf("毕业年份") > -1) {
    fields += ";education_graduation_year";
  }
  if (checkList.indexOf("联系电话") > -1) {
    fields += ";mobile_phone";
  }
  if (checkList.indexOf("微信") > -1) {
    fields += ";wechat";
  }
  if (checkList.indexOf("生源地") > -1) {
    fields += ";origin_place";
  }
  if (checkList.indexOf("生源高中") > -1) {
    fields += ";origin_high_school";
  }
  if (checkList.indexOf("校友类别") > -1) {
    fields += ";alumni_type";
  }
  if (checkList.indexOf("是否本硕连读") > -1) {
    fields += ";is_bachelors_masters";
  }
  if (checkList.indexOf("其他") > -1) {
    fields += ";education_other";
  }
  return fields;
}

/**
 * 获取校友工作信息筛选字段
 */
export function getJobInfoFields(checkList) {
  var fields = "student_no;name_cn;name_en";
  if (checkList.indexOf("专业") > -1) {
    fields += ";programme";
  }
  if (checkList.indexOf("入学年份") > -1) {
    fields += ";year";
  }
  if (checkList.indexOf("状态") > -1) {
    fields += ";status";
  }
  if (checkList.indexOf("所在地") > -1) {
    fields += ";organization_nation;organization_province;organization_city";
  }
  if (checkList.indexOf("单位名称") > -1) {
    fields += ";organization";
  }
  if (checkList.indexOf("单位性质") > -1) {
    fields += ";unit_property";
  }
  if (checkList.indexOf("行业类型") > -1) {
    fields += ";job_type";
  }
  if (checkList.indexOf("工作职位") > -1) {
    fields += ";position";
  }
  if (checkList.indexOf("薪酬范围") > -1) {
    fields += ";pay";
  }
  if (checkList.indexOf("公司注册地") > -1) {
    fields += ";registered_address";
  }
  if (checkList.indexOf("雇员人数") > -1) {
    fields += ";employees";
  }
  if (checkList.indexOf("年营业额") > -1) {
    fields += ";turnover";
  }
  if (checkList.indexOf("从事何种自由职业") > -1) {
    fields += ";freelance";
  }
  if (checkList.indexOf("联系电话") > -1) {
    fields += ";mobile_phone";
  }
  if (checkList.indexOf("微信") > -1) {
    fields += ";wechat";
  }
  if (checkList.indexOf("生源地") > -1) {
    fields += ";origin_place";
  }
  if (checkList.indexOf("生源高中") > -1) {
    fields += ";origin_high_school";
  }
  if (checkList.indexOf("校友类别") > -1) {
    fields += ";alumni_type";
  }
  if (checkList.indexOf("是否本硕连读") > -1) {
    fields += ";is_bachelors_masters";
  }
  return fields;
}

/**
 * 获取校友捐助信息筛选字段
 */
export function getJournalInfoFields(checkList) {
  var fields = "student_no;name_cn;name_en";
  if (checkList.indexOf("专业") > -1) {
    fields += ";programme";
  }
  if (checkList.indexOf("捐助时间") > -1) {
    fields += ";journal_time";
  }
  if (checkList.indexOf("与学校关系") > -1) {
    fields += ";relation";
  }
  if (checkList.indexOf("入校时间") > -1) {
    fields += ";year";
  }
  if (checkList.indexOf("捐助内容") > -1) {
    fields += ";content";
  }
  if (checkList.indexOf("票据") > -1) {
    fields += ";bill_status";
  }
  if (checkList.indexOf("证书") > -1) {
    fields += ";certificate_status";
  }
  if (checkList.indexOf("捐助金额") > -1) {
    fields += ";money";
  }
  if (checkList.indexOf("捐助类型") > -1) {
    fields += ";type";
  }
  if (checkList.indexOf("校友类别") > -1) {
    fields += ";alumni_type";
  }
  if (checkList.indexOf("是否本硕连读") > -1) {
    fields += ";is_bachelors_masters";
  }
  if (checkList.indexOf("备注") > -1) {
    fields += ";remark";
  }
  return fields;
}

/**
 * 获取校友荣誉信息筛选字段
 */
export function getHonorInfoFields(checkList) {
  var fields = "student_no;name_cn;name_en";
  if (checkList.indexOf("专业") > -1) {
    fields += ";programme";
  }
  if (checkList.indexOf("荣誉时间") > -1) {
    fields += ";honor_time";
  }
  if (checkList.indexOf("荣誉内容") > -1) {
    fields += ";content";
  }
  if (checkList.indexOf("校友类别") > -1) {
    fields += ";alumni_type";
  }
  if (checkList.indexOf("是否本硕连读") > -1) {
    fields += ";is_bachelors_masters";
  }
  return fields;
}

/**
 * 是否显示隐藏
 */
export function getStates(states) {
  for (let index = 0; index < Constant.options_status.length; index++) {
    const info = Constant.options_status[index];
    if (info.en == states) {
      return info.cn;
    }
  }
  return "*";
}
/**
 * 获取类型
 */
export function getType(type) {
  for (let index = 0; index < Constant.options_type.length; index++) {
    const info = Constant.options_type[index];
    if (info.en == type) {
      return info.cn;
    }
  }
  return "*";
}
/**
 * 列表转字符串
 */
export function getStr4List(list) {
  var str = "";
  if (list) {
    list.forEach(info => {
      str += info + ",";
    });
    if (!isEmpty(str)) {
      str = str.substring(0, str.length - 1);
    }
  }
  return str;
}
export function getStr4List1(list) {
  var str = "";
  if (list) {
    list.forEach(info => {
      str += info + ";";
    });
    if (!isEmpty(str)) {
      str = str.substring(0, str.length - 1);
    }
  }
  return str;
}
// 补0
export function formatBit(val) {
  val = +val;
  return val > 9 ? val : "0" + val;
}
// 秒转时分秒，求模很重要，数字的下舍入
export function formatSeconds(time) {
  let min = Math.floor(time % 3600);
  let hh = formatBit(Math.floor(time / 3600));
  let mm = formatBit(Math.floor(min / 60));
  let ss = formatBit(time % 60);
  let val = "";
  if (hh == "00") hh = "0";
  if (mm == "00") mm = "0";
  if (ss == "00") ss = "0";
  if (hh > 0) val = hh + "时";
  if (mm > 0) val = val + mm + "分";
  if (ss) val = val + ss + "秒";
  return val;
}

//  获取票据状态 ,// 票据状态  NO未申请，APPLY已申请，MAIL已寄送
export function getBillStatus(status) {
  switch (status) {
    case "NO":
      return "未申请";
    case "APPLY":
      return "已申请";
    case "MAIL":
      return "已寄送";
  }
}

//  纸质证书状态 // 证书状态  NO未申请，APPLY已申请，MAIL已寄送
export function getCertificateStatus(status) {
  switch (status) {
    case "NO":
      return "未申请";
    case "APPLY":
      return "已申请";
    case "MAIL":
      return "已寄送";
  }
}

//  校友积分
export function getIntegralTotal(num) {
  if (num < 1000) {
    return num;
  } else {
    return (num / 1000).toFixed(1) + "k";
  }
}



// WEBPACK FOOTER //
// ./src/utils/strUtils.js